import { render, staticRenderFns } from "./manageTasks.vue?vue&type=template&id=0484f08c&scoped=true"
import script from "./manageTasks.vue?vue&type=script&lang=js"
export * from "./manageTasks.vue?vue&type=script&lang=js"
import style0 from "./manageTasks.vue?vue&type=style&index=0&id=0484f08c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0484f08c",
  null
  
)

export default component.exports